

export const products = [
    {
        id: 1,
        name: "5 x 4 Bouquet Preserved Flower Bookends set, Wedding bouquet",
        price: 200,
        salePrice: 187,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/11d607/7245821481/il_1588xN.7245821481_29ah.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/11d607/7245821481/il_1588xN.7245821481_29ah.jpg",
            "https://i.etsystatic.com/26472238/r/il/bafef0/7196506196/il_1588xN.7196506196_3kea.jpg",
            "https://i.etsystatic.com/26472238/r/il/6f0e25/7197912332/il_1588xN.7197912332_qgj2.jpg",
        ],
        category: "Bookends",
        isOnSale: true,
        dateAdded: "2024-07-15",
        description: "Resin bookends, resin preserved bookends, Bouquet Preservation, Wedding gifts, Preserve your flowers from your special day in beautiful resin book ends.",
        details: {
            material: "Epoxy",
            care: "Machine wash cold, tumble dry low",
            sizes: ["5x4", "7.5x9"],
            features: [
                "Your flowers are carefully dried to keep their natural colors then layered in resin.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Book ends each measure: 5\"x4\"\n" +
                "\n" +
                "5 inch tall and 4 inch width\n" +
                "\n" +
                "***The 5\" bookends are a set!\n" +
                "\n" +
                "\n" +
                "\n" +
                "Turn your special flowers into works of art that lasts a lifetime! The bookends offer an innovative way to reminisce on special memories in your life while adding a personal touch to your home decor. Bookends add that romantic dreamy touch to any personal library as well as functionally hold your books.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Each bookend is personalized to your vision for your flowers, and we provide you a detailed journey for your flowers along the preservation process. I provide updates for each step of the process and will send you mock up photos of your design for your approval.\n" +
                "\n" +
                "\n" +
                "\n" +
                "It is My honor to preserve your flowers.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Check the wedding section for more preservation ideas.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Every item is handmade and there may be minor imperfections and air bubbles. I work very hard to minimize any imperfections.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Flowers will need at least 2 to 3 weeks for the drying process and 2 to 3 weeks for the design process. Total processing time is between 3 to 4 weeks. "
            ]
        }
    },
    {
        id: 2,
        name: "7 x 5 Preserved Wedding Flower Resin Bookends",
        price: 249.99,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/1e84fd/7196296266/il_1588xN.7196296266_9ndy.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/0f798b/7667388083/il_1588xN.7667388083_bos5.jpg",
            "https://i.etsystatic.com/26472238/r/il/3ceaee/7667388003/il_1588xN.7667388003_rsv1.jpg",
            "https://i.etsystatic.com/26472238/r/il/0c4590/7619444014/il_1588xN.7619444014_rled.jpg",
            "https://i.etsystatic.com/26472238/r/il/49b257/7619443932/il_1588xN.7619443932_ofi1.jpg"
        ],
        category: "Bookends",
        isOnSale: false,
        dateAdded: "2024-07-20",
        description: "Book ends each measure: 7 x 5",
        details: {
            material: "Epoxy, flowers",
            care: "",
            sizes: ["7 x 5"],
            features: [
                "Your flowers are carefully dried to keep their natural colors then layered in resin.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Book ends each measure: 7\"x5\"\n" +
                "\n" +
                "7 inch tall and 5 inch width\n" +
                "\n" +
                "***The 7\" bookends are a set!\n" +
                "\n" +
                "\n" +
                "\n" +
                "Turn your special flowers into works of art that lasts a lifetime! The bookends offer an innovative way to reminisce on special memories in your life while adding a personal touch to your home decor. Bookends add that romantic dreamy touch to any personal library as well as functionally hold your books.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Each bookend is personalized to your vision for your flowers, and we provide you a detailed journey for your flowers along the preservation process. I provide updates for each step of the process and will send you mock up photos of your design for your approval.\n" +
                "\n" +
                "\n" +
                "\n" +
                "It is My honor to preserve your flowers.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Check the wedding section for more preservation ideas.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Every item is handmade and there may be minor imperfections and air bubbles. I work very hard to minimize any imperfections.\n" +
                "\n" +
                "\n" +
                "\n" +
                "Flowers will need at least 2 to 3 weeks for the drying process and 2 to 3 weeks for the design process. Total processing time is between 3 to 4 weeks. "
            ]
        }
    },
    {
        id: 3,
        name: "6 x 6 Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        price: 140.00,
        salePrice: 127.50,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/81b162/7603500336/il_1588xN.7603500336_3z3j.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/8ab84a/7603487798/il_1588xN.7603487798_3bwm.jpg",
            "https://i.etsystatic.com/26472238/r/il/a17bf9/7603479312/il_1588xN.7603479312_orne.jpg",
            "https://i.etsystatic.com/26472238/r/il/32f300/7651423153/il_1588xN.7651423153_m49x.jpg",
            "https://i.etsystatic.com/26472238/r/il/e8a9d9/7651423155/il_1588xN.7651423155_g181.jpg"
        ],
        category: "Block",
        isOnSale: true,
        dateAdded: "2024-07-25",
        description: "Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        details: {
            material: "Epoxy",
            care: "",
            features: [
                " ✨ Wedding Bouquet Preservation Resin Block ✨",
                "Turn your special flowers into a timeless keepsake! 🌸 Whether it’s your wedding bouquet, anniversary florals, memorial flowers, or blooms from any important day, I’ll preserve them in a stunning resin block so you can treasure them forever."
            ]
        }
    },
    {
        id: 4,
        name: "8 x 8 Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        price: 140.00,
        salePrice: 127.50,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/328da2/7603500344/il_1588xN.7603500344_17j3.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/8ab84a/7603487798/il_1588xN.7603487798_3bwm.jpg",
            "https://i.etsystatic.com/26472238/r/il/a17bf9/7603479312/il_1588xN.7603479312_orne.jpg",
            "https://i.etsystatic.com/26472238/r/il/32f300/7651423153/il_1588xN.7651423153_m49x.jpg",
            "https://i.etsystatic.com/26472238/r/il/e8a9d9/7651423155/il_1588xN.7651423155_g181.jpg"
        ],
        category: "Block",
        isOnSale: true,
        dateAdded: "2024-07-25",
        description: "Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        details: {
            material: "Epoxy",
            care: "",
            features: [
                " ✨ Wedding Bouquet Preservation Resin Block ✨",
                "Turn your special flowers into a timeless keepsake! 🌸 Whether it’s your wedding bouquet, anniversary florals, memorial flowers, or blooms from any important day, I’ll preserve them in a stunning resin block so you can treasure them forever."
            ]
        }
    },
    {
        id: 5,
        name: "10 x 10 Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        price: 140.00,
        salePrice: 127.50,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/568fba/7250129027/il_1588xN.7250129027_mlzb.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/8ab84a/7603487798/il_1588xN.7603487798_3bwm.jpg",
            "https://i.etsystatic.com/26472238/r/il/a17bf9/7603479312/il_1588xN.7603479312_orne.jpg",
            "https://i.etsystatic.com/26472238/r/il/32f300/7651423153/il_1588xN.7651423153_m49x.jpg",
            "https://i.etsystatic.com/26472238/r/il/e8a9d9/7651423155/il_1588xN.7651423155_g181.jpg"
        ],
        category: "Block",
        isOnSale: true,
        dateAdded: "2024-07-25",
        description: "Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        details: {
            material: "Epoxy",
            care: "",
            features: [
                " ✨ Wedding Bouquet Preservation Resin Block ✨",
                "Turn your special flowers into a timeless keepsake! 🌸 Whether it’s your wedding bouquet, anniversary florals, memorial flowers, or blooms from any important day, I’ll preserve them in a stunning resin block so you can treasure them forever."
            ]
        }
    },
    {
        id: 6,
        name: "12 x 12 Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        price: 140.00,
        salePrice: 127.50,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/9ccf7c/7603479300/il_1588xN.7603479300_b1db.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/8ab84a/7603487798/il_1588xN.7603487798_3bwm.jpg",
            "https://i.etsystatic.com/26472238/r/il/a17bf9/7603479312/il_1588xN.7603479312_orne.jpg",
            "https://i.etsystatic.com/26472238/r/il/32f300/7651423153/il_1588xN.7651423153_m49x.jpg",
            "https://i.etsystatic.com/26472238/r/il/e8a9d9/7651423155/il_1588xN.7651423155_g181.jpg"
        ],
        category: "Block",
        isOnSale: true,
        dateAdded: "2024-07-25",
        description: "Wedding Bouquet Resin Block, Floral Keepsake, Flower Preservation",
        details: {
            material: "Epoxy",
            care: "",
            features: [
                " ✨ Wedding Bouquet Preservation Resin Block ✨",
                "Turn your special flowers into a timeless keepsake! 🌸 Whether it’s your wedding bouquet, anniversary florals, memorial flowers, or blooms from any important day, I’ll preserve them in a stunning resin block so you can treasure them forever."
            ]
        }
    },
    {
        id: 7,
        name: "Flower Arch , wedding bouquet preservation, flowers in resin, keepsake",
        price: 150,
        salePrice: 127.55,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/9fb00e/7811800743/il_1588xN.7811800743_42xn.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/b8f287/7763851910/il_1588xN.7763851910_dkcn.jpg",
            "https://i.etsystatic.com/26472238/r/il/4e521f/7619432608/il_1588xN.7619432608_16gw.jpg",
            "https://i.etsystatic.com/26472238/r/il/9e2c0a/7667376515/il_1588xN.7667376515_4vo8.jpg"
        ],
        category: "Arch",
        isOnSale: true,
        dateAdded: "2024-07-15",
        description: "Preserve your flowers from your special day in beautiful resin arch stand.",
        details: {
            material: "Epoxy, flowers",

            features: [
                "Preserve your flowers from your special day in beautiful resin arch stand. Your flowers are carefully dried to keep their natural colors then layered in resin.",
                "Turn your special flowers into works of art that lasts a lifetime! an innovative way to reminisce on special memories in your life while adding a personal touch to your home decor.\n" +
                "it add that romantic dreamy touch to any house",
                "Each Arch is personalized to your vision for your flowers, and we provide you a detailed journey for your flowers along the preservation process. I provide updates for each step of the process and will send you mock up photos of your design for your approval.\n"
            ]
        }
    },
    {
        id: 8,
        name: "Large Dried Flower Resin Cross: Spiritual Memorial Gift (7x12”)",
        price: 206.99,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/d947d4/7255814121/il_1588xN.7255814121_o82l.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/7e3b36/7793843203/il_1588xN.7793843203_9ykc.jpg",
            "https://i.etsystatic.com/26472238/r/il/2ba740/7355645151/il_1588xN.7355645151_8fm3.jpg",
            "https://i.etsystatic.com/26472238/r/il/d00c99/7355645149/il_1588xN.7355645149_s6eu.jpg",
            "https://i.etsystatic.com/26472238/r/il/e7233d/7355645145/il_1588xN.7355645145_cs2a.jpg",
            "https://i.etsystatic.com/26472238/r/il/2ba740/7355645151/il_1588xN.7355645151_8fm3.jpg",
            "https://i.etsystatic.com/26472238/r/il/935a7e/7745886622/il_1588xN.7745886622_fn2o.jpg"
        ],
        category: "Cross",
        isOnSale: false,
        dateAdded: "2024-07-20",
        description: "Beautiful Pressed-Flower Epoxy Resin Cross – 7″ × 5.5″ Keepsake\n" +
            "Capture the delicate beauty of real blooms in a unique, handcrafted decorative cross—perfect as meaningful home décor or a heartfelt gift.",
        details: {
            material: "Epoxy, flowers",
            features: [
                "Beautiful Pressed-Flower Epoxy Resin Cross – 7″ × 5.5″ Keepsake\n" +
                "Made-to-order with your choice of fresh, pre‑dried, or fake flowers",
                "Crystal-clear resin showcases every petal and hue"
            ]
        }
    },
    {
        id: 9,
        name: "9x7 LARGE Preserved Flower frame for 4x3 photo Bridal Keepsake | Preserve Flower Frame| Wedding Gift Bouquet Preservation ",
        price: 300.00,
        salePrice: 225.00,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/b5fdd3/7196345320/il_1588xN.7196345320_qi02.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/64f4db/7196345328/il_1588xN.7196345328_kzc3.jpg",
            "https://i.etsystatic.com/26472238/r/il/db08dc/7619468688/il_1588xN.7619468688_g3gm.jpg",
            "https://i.etsystatic.com/26472238/r/il/890444/7667412621/il_1588xN.7667412621_534w.jpg",
            "https://i.etsystatic.com/26472238/r/il/e92deb/7667412657/il_1588xN.7667412657_l031.jpg",
            "https://i.etsystatic.com/26472238/r/il/a3f634/7667412655/il_1588xN.7667412655_jhun.jpg",
            "https://i.etsystatic.com/26472238/r/il/dd0b02/7667412643/il_1588xN.7667412643_dwaw.jpg",
            "https://i.etsystatic.com/26472238/r/il/462b43/7667412623/il_1588xN.7667412623_hkbq.jpg"
        ],
        category: "Frame",
        isOnSale: true,
        dateAdded: "2024-07-25",
        description: "9X7 LARGE Preserved Flower frame for 4x3 photo Bridal Keepsake | Preserve Flower Frame| Wedding Gift Bouquet Preservation ",
        details: {
            material: "Epoxy, flowers",
            features: [
                "✨ Resin Preserved Photo Frame – A Forever Keepsake ✨\n" +
                "Capture the magic of your special day with our handmade resin photo frame, designed to preserve your bridal bouquet or favorite flowers in a timeless display.",
                "💐 Dried Floral Preservation – We carefully dry your real flowers to maintain their color, texture, and beauty, then encase them in crystal-clear resin for lasting elegance.\n",
                "📸 Custom Bridal Keepsake – Whether from your wedding bouquet, memorial flowers, or a meaningful event, this frame becomes a heartfelt way to treasure the moment."
            ]
        }
    },
    {
        id: 10,
        name: "8.3 Inch Large Heart Preserved Bouquet, Dried Flower Preservation, Bridal Bouquet Preservation, custom wedding keepsake, photo keepsake block",
        price: 187.50,
        imageUrl: "https://dgmart-images.s3.us-east-2.amazonaws.com/il_1588xN.7245805791_no07.webp",
        images: [
            "https://i.etsystatic.com/26472238/r/il/6f2027/7244484935/il_1588xN.7244484935_70a4.jpg",
        ],
        category: "Heart",
        isOnSale: false,
        dateAdded: "2024-07-10",
        description: "8.3 Inch Large Heart Preserved Bouquet, Dried Flower Preservation, Bridal Bouquet Preservation, custom wedding keepsake, photo keepsake block.",
        details: {
            material: "Epoxy, flowers",
            features: [
                "Creating a bridal bouquet preserved in epoxy resin within a heart shape can be a beautiful and sentimental keepsake. Send your  flowers to us and we'll create Unique heart-shaped decorations for your home.",
                "Cherish the memories of special moments forever with our handcrafted heart-shaped epoxy resin flower-preserved pieces. Each piece encapsulates the beauty of meticulously arranged flowers within a crystal-clear resin, creating an everlasting display of love and beauty.",
                "Weddings & Anniversaries: Capture the essence of your special day or celebrate milestone anniversaries with a timeless piece that encapsulates the joy and love of that moment."
            ]
        }
    },
    {
        id: 11,
        name: "7 x 5.5 Stand Cross With Dried Flowers - Memorial- spiritual Gift- Small Flowers Petals - Cross Religious -sympathy gift.",
        price: 52.50,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/6769d0/7811808567/il_1588xN.7811808567_gjwn.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/605edd/7811808573/il_1588xN.7811808573_gwfx.jpg",
            "https://i.etsystatic.com/26472238/r/il/bc8979/7103809483/il_1588xN.7103809483_3e59.jpg",
            "https://i.etsystatic.com/26472238/r/il/43e51d/7793833211/il_1588xN.7793833211_k4v7.jpg",
            "https://i.etsystatic.com/26472238/r/il/ea4057/7745876574/il_1588xN.7745876574_4n67.jpg",
            "https://i.etsystatic.com/26472238/r/il/cb1a53/7793833209/il_1588xN.7793833209_ni7s.jpg"
        ],
        category: "Cross",
        isOnSale: false,
        dateAdded: "2024-07-05",
        description: "Beautiful Pressed-Flower Epoxy Resin Cross – 7″ × 5.5″ Keepsake",
        details: {
            material: "Epoxy, flowers",
            features: [
                "Ruffled sleeves",
                "Pearl buttons",
                "Peter pan collar",
                "Subtle peplum hem"
            ]
        }
    },
    {
        id: 12,
        name: "Custom Floral Resin Letter: Preserved Wedding Bouquet Initial (5x7) ",
        price: 129.99,
        salePrice: 97.51,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/aaddeb/7198200170/il_1588xN.7198200170_k4c9.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/11c0a2/6043037048/il_1588xN.6043037048_7bji.jpg",
            "https://i.etsystatic.com/26472238/r/il/f83463/6351595873/il_1588xN.6351595873_2y4d.jpg",
            "https://i.etsystatic.com/26472238/r/il/37f488/6091109215/il_1588xN.6091109215_4kh9.jpg"
        ],
        category: "Letter",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: "Custom Floral Resin Letter: Preserved Wedding Bouquet Initial (5x7) ",
        details: {
            material: "Epoxy, flowers",
            sizes: ["&", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
            features: [
                "Custom letter initial with flowers . Could be my flowers or your bouquet. DM for options.",
                "Choose your letter and send me flowers that you want.",
                "When preserving please be aware that large flowers cannot be accommodated do to the letters, reason being that the molds are 1 in depth.",
                "Smaller roses or flowers of that size are perfect ( mini roses or 1-1.25 flowers)."
            ]
        }
    },
    {
        id: 13,
        name: " Wedding Bouquet Charcuterie Board 8 x 11 inch",
        price: 350.55,
        salePrice: 262.55,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/b86881/7667568641/il_1588xN.7667568641_n4e6.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/a6ccf0/6548544360/il_1588xN.6548544360_ndux.jpg",
            "https://i.etsystatic.com/26472238/r/il/f1af23/7244490123/il_1588xN.7244490123_noes.jpg",
            "https://i.etsystatic.com/26472238/r/il/6c0c32/7667576717/il_1588xN.7667576717_50vw.jpg",
            "https://i.etsystatic.com/26472238/r/il/09f000/6596662539/il_1588xN.6596662539_g4k8.jpg",
            "https://i.etsystatic.com/26472238/r/il/8ef799/7619632240/il_1588xN.7619632240_su0z.jpg",
            "https://i.etsystatic.com/26472238/r/il/d0a6a4/6548544698/il_1588xN.6548544698_bky5.jpg",
            "https://i.etsystatic.com/26472238/r/il/bfcab6/7619632242/il_1588xN.7619632242_opvf.jpg"
        ],
        category: "Board",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: " Wedding Bouquet Charcuterie Board 8 x 11 inch",
        details: {
            material: "Epoxy, flowers",
            features: [
                "This exquisite serving tray is a one-of-a-kind keepsake, handcrafted from durable epoxy resin and adorned with real wedding flowers, carefully preserved to capture their beauty for years to come.\n" +
                "The transparent resin highlights the delicate petals and greenery, creating a timeless, elegant design that combines functionality with sentimentality. ",
                "Perfect for serving drinks, displaying decor, or as a meaningful gift, this tray is both a work of art and a cherished memory from your special day.",
                "Length: 11 inches",
                "Width: 8 inches",
                "Thickness: 1 inch or more"
            ]
        }
    },
    {
        id: 14,
        name: "Floral Resin Ring Holder Dish: Bridal Jewelry Tray with Preserved Flowers ",
        price: 45.11,
        salePrice: 33.75,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/45f980/7241962646/il_1588xN.7241962646_ka9i.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/528f35/7289919245/il_1588xN.7289919245_aay1.jpg",
            "https://i.etsystatic.com/26472238/r/il/4220b6/7244495539/il_1588xN.7244495539_7oeq.jpg",
            "https://i.etsystatic.com/26472238/r/il/4e7f08/7289919247/il_1588xN.7289919247_8q7x.jpg"
        ],
        category: "Tray",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: "Floral Resin Ring Holder Dish: Bridal Jewelry Tray with Preserved Flowers ",
        details: {
            material: "Epoxy, flowers",
            features: [
                "Jewelry type: Necklace, Ring",
                "These stunning jewelry trays, made with real preserved flowers, are the perfect place to hold your favorite pieces!",
                "Create a custom tray with your own florals.\n" +
                "Please note: flowers may vary, as each bloom is beautifully unique 💕 "
            ]
        }
    },
    {
        id: 15,
        name: "6x8 Resin Preserved Frame 4x3 photo SMALL FLOWERS / PETALS | Bridal Keepsake | Preserve Flower Frame| Wedding Gift Bouquet Preservation ",
        price: 75,
        salePrice: 56.25,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/7c53ea/7619519116/il_1588xN.7619519116_m9x4.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/9999fb/7811804337/il_1588xN.7811804337_6whh.jpg",
            "https://i.etsystatic.com/26472238/r/il/821b75/7667463535/il_1588xN.7667463535_k1id.jpg",
            "https://i.etsystatic.com/26472238/r/il/1204a1/7245898637/il_1588xN.7245898637_5ln3.jpg",
            "https://i.etsystatic.com/26472238/r/il/ed4f14/7811804329/il_1588xN.7811804329_nehb.jpg"
        ],
        category: "Frame",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: "6x8 Resin Preserved Frame 4x3 photo SMALL FLOWERS / PETALS | Bridal Keepsake | Preserve Flower Frame| Wedding Gift Bouquet Preservation ",
        details: {
            material: "Epoxy, flowers",
            features: [
                "✨ Resin Preserved Photo Frame – A Forever Keepsake ✨\n" +
                "Capture the magic of your special day with our handmade resin photo frame, designed to preserve your bridal bouquet or favorite flowers in a timeless display.",
                "Dried Floral Preservation – We carefully press and dry your real flowers to maintain their color, texture, and beauty, then encase them in crystal-clear resin for lasting elegance.",
                "Custom Bridal Keepsake – Whether from your wedding bouquet, memorial flowers, or a meaningful event, this frame becomes a heartfelt way to treasure the moment.",
                "Preserve Flower Frame – Each piece is handcrafted with attention to detail, turning your blooms into a piece of art. Display it in your home, on a desk, or as a centerpiece."
            ]
        }
    },
    {
        id: 16,
        name: "Wine Bottle Stoppers, Bar Decor, Unique Wine Corks, Bouquet Preservation, Bouquet Wine Stopper, Preserved Wedding Flowers, Dried Flowers ",
        price: 55.00,
        salePrice: 41.25,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/8a5f11/7793862155/il_1588xN.7793862155_4fwi.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/15b893/6055385029/il_1588xN.6055385029_ztrl.jpg",
            "https://i.etsystatic.com/26472238/r/il/a881d0/5983788126/il_1588xN.5983788126_eosu.jpg",
            "https://i.etsystatic.com/26472238/r/il/feb3d4/5983787072/il_1588xN.5983787072_gklz.jpg"
        ],
        category: "Letter",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: "Wine Bottle Stoppers, Bar Decor, Unique Wine Corks, Bouquet Preservation, Bouquet Wine Stopper, Preserved Wedding Flowers, Dried Flowers ",
        details: {
            material: "Epoxy, flowers",
            sizes: ["1", "2", "3", "4", "5"],
            features: [
                "Elevate your wine experience with our exquisite Wine Bottle Stoppers, the perfect fusion of functionality and elegance. Crafted for wine enthusiasts and connoisseurs alike, these stoppers not only preserve your favorite bottle but also add a touch of sophistication to your bar decor.",
                "But these stoppers are more than just a decorative accent—they are also a beautiful way to preserve memories. You can immortalize the beauty of your special occasions.\n" +
                "a stunning keepsake that captures the essence of your most cherished moments.",
                "Indulge in the art of bouquet preservation and let your wine bottles tell a story. Whether it's a romantic wedding, a milestone anniversary, or a memorable celebration, our Wine Bottle Stoppers offer a timeless way to commemorate life's precious milestones. "
            ]
        }
    },
    {
        id: 17,
        name: "9 Hexagon Bouquet Preservation Block: Dried Flower Resin Art ",
        price: 270,
        salePrice: 202.50,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/449a54/7745915898/il_1588xN.7745915898_hf8m.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/502cea/7793872505/il_1588xN.7793872505_9upg.jpg",
            "https://i.etsystatic.com/26472238/r/il/6774fe/7667480935/il_1588xN.7667480935_95mp.jpg",
            "https://i.etsystatic.com/26472238/r/il/4699de/6711372220/il_1588xN.6711372220_dnip.jpg"
        ],
        category: "Letter",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: "9” Hexagon Bouquet Block",
        details: {
            material: "Epoxy, flowers",
            sizes: ["&", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
            features: [
                "9” Hexagon Bouquet Block",
                "Turn your special flowers into works of art that lasts a lifetime! Our team of experts can transform your flowers into a hexagon bouquet block. Our hexagon bouquet blocks offer an innovative way to reminisce on special memories in your life while adding a personal touch to your home decor. Hexagon bouquet blocks are a gorgeous addition to your home bookshelf, boudoir, and more. This bouquet block is unique from our others because of its larger size and shape. Each bouquet block is personalized to your vision for your flowers, and we provide you a detailed journey for your flowers along the preservation process. "
            ]
        }
    },
    {
        id: 18,
        name: "Custom Floral Resin Letter: Preserved Wedding Bouquet Initial (5x7) ",
        price: 129.99,
        salePrice: 97.51,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/aaddeb/7198200170/il_1588xN.7198200170_k4c9.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/11c0a2/6043037048/il_1588xN.6043037048_7bji.jpg",
            "https://i.etsystatic.com/26472238/r/il/f83463/6351595873/il_1588xN.6351595873_2y4d.jpg",
            "https://i.etsystatic.com/26472238/r/il/37f488/6091109215/il_1588xN.6091109215_4kh9.jpg"
        ],
        category: "Letter",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: "Custom Floral Resin Letter: Preserved Wedding Bouquet Initial (5x7) ",
        details: {
            material: "Epoxy, flowers",
            sizes: ["&", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
            features: [
                "Custom letter initial with flowers . Could be my flowers or your bouquet. DM for options.",
                "Choose your letter and send me flowers that you want.",
                "When preserving please be aware that large flowers cannot be accommodated do to the letters, reason being that the molds are 1 in depth.",
                "Smaller roses or flowers of that size are perfect ( mini roses or 1-1.25 flowers)."
            ]
        }
    },
    {
        id: 19,
        name: "Hexagon Resin Bouquet Preservation Block, Dried Flower Keepsake (9 inch)",
        price: 129.99,
        salePrice: 97.51,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/9ada53/7096799171/il_1588xN.7096799171_lrxy.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/9eb388/7096790849/il_1588xN.7096790849_aa1s.jpg",
            "https://i.etsystatic.com/26472238/r/il/ffc990/7745921760/il_1588xN.7745921760_gzw3.jpg",
            "https://i.etsystatic.com/26472238/r/il/e67dab/7793878439/il_1588xN.7793878439_nrqd.jpg"
        ],
        category: "Letter",
        isOnSale: true,
        dateAdded: "2024-07-01",
        description: "9” Hexagon Bouquet Block" +
            "Turn your special flowers into works of art that lasts a lifetime! Our team of experts can transform your flowers into a hexagon bouquet block. Our hexagon bouquet blocks offer an innovative way to reminisce on special memories in your life while adding a personal touch to your home decor. Hexagon bouquet blocks are a gorgeous addition to your home bookshelf, boudoir, and more. This bouquet block is unique from our others because of its larger size and shape. Each bouquet block is personalized to your vision for your flowers, and we provide you a detailed journey for your flowers along the preservation process.",
        details: {
            material: "Epoxy, flowers",
           features: [
                "C9” Hexagon Bouquet Block Turn your special flowers into works of art that lasts a lifetime! Our team of experts can transform your flowers into a hexagon bouquet block. Our hexagon bouquet blocks offer an innovative way to reminisce on special memories in your life while adding a personal touch to your home decor. Hexagon bouquet blocks are a gorgeous addition to your home bookshelf, boudoir, and more. This bouquet block is unique from our others because of its larger size and shape. Each bouquet block is personalized to your vision for your flowers, and we provide you a detailed journey for your flowers along the preservation process."
            ]
        }
    },
    {
        id: 20,
        name: "Large Resin Arch",
        price: 127.00,
        imageUrl: "https://blossomandrhyme.com/cdn/shop/files/DSC_0205.jpg?v=1714751351",
        images: [
            "https://blossomandrhyme.com/cdn/shop/files/DSC_0205.jpg?v=1714751351",
            "https://blossomandrhyme.com/cdn/shop/files/DSC_0550.jpg?v=1722456245",
            "https://blossomandrhyme.com/cdn/shop/files/DSC_0632.jpg?v=1715699857",
            "https://blossomandrhyme.com/cdn/shop/files/IMG_6078.heic?v=1715699857",
            "https://blossomandrhyme.com/cdn/shop/files/IMG_8994.jpg?v=1715699857"
        ],
        category: "preservation",
        isOnSale: false,
        dateAdded: "2024-08-01",
        description: "Crafted in a distinctive arch style mold, it gracefully preserves your cherished memories and special flowers for years to come. This 6x10 inch piece is one of our most popular items.",
        details: {
            material: "High-quality, UV-resistant Resin",
            care: "Keep out of direct sunlight to prevent yellowing over time. Clean with a soft, damp cloth.",
            dimensions: "6 x 10 inches",
            features: [
                "Distinctive arch shape",
                "Crystal clear finish",
                "Custom flower arrangement",
                "Handcrafted with care",
                "Long-lasting preservation"
            ]
        }
    },
    {
        id: 21,
        name: "Resin Candle Holder with Dried Flower Preservation",
        price: 43.00,
        imageUrl: "https://i.etsystatic.com/26472238/r/il/3a05ca/6127568439/il_1588xN.6127568439_g9oy.jpg",
        images: [
            "https://i.etsystatic.com/26472238/r/il/b8cad8/6127568779/il_1588xN.6127568779_pcaa.jpg",
            "https://i.etsystatic.com/26472238/r/il/514b40/6079505810/il_1588xN.6079505810_1nhv.jpg",
            "https://i.etsystatic.com/26472238/r/il/348d2c/6079505652/il_1588xN.6079505652_n6b9.jpg",
            "https://i.etsystatic.com/26472238/r/il/0153a1/6279085029/il_1588xN.6279085029_n5pz.jpg"
        ],
        category: "preservation",
        isOnSale: false,
        dateAdded: "2024-08-01",
        description: "These custom resin coasters are handcrafted using your real dried wedding, memorial, or any other meaningful flowers, turning precious moments into a timeless keepsake you can cherish every day.",
        details: {
            material: "High-quality, UV-resistant Resin",
            features: [
                "Distinctive arch shape",
                "Crystal clear finish",
                "Custom flower arrangement",
                "Handcrafted with care",
                "Long-lasting preservation"
            ]
        }
    }
];


